<template>
  <section class="panel">
    <p class="panel-heading">{{ title }}</p>
    <div class="columns is-mobile is-multiline is-centered">
      <div
        class="column is-one-third-mobile is-one-third-tablet is-2-desktop"
        v-for="aspect in getSectionAspects()"
        :key="aspect"
      >
        <Clue :aspect="aspect" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Clue from './Clue.vue';

export default {
  name: 'Section',
  components: {
    Clue,
  },

  props: {
    id: String,
    title: String,
  },

  computed: mapGetters('aspects', ['sectionAspects']),

  methods: {
    getSectionAspects() {
      return this.sectionAspects(this.id);
    },
  },
};
</script>

<style scoped>
.panel-heading {
  font-weight: bold;
  text-transform: uppercase;
  font-size: +1rem;
}
</style>
